import React from 'react';
import './EmptyState.css';

/**
 * Shared empty-state for lists, tables, and card views.
 */
export default function EmptyState({
  icon = 'fas fa-inbox',
  title = 'No Data Found',
  description = 'Nothing to display right now.',
  action = null,
  className = '',
}) {
  return (
    <div className={`fd-empty-state ${className}`.trim()}>
      <div className="fd-empty-state__icon" aria-hidden="true">
        {typeof icon === 'string' ? <i className={icon} /> : icon}
      </div>
      <h3 className="fd-empty-state__title">{title}</h3>
      {description ? (
        <p className="fd-empty-state__description">{description}</p>
      ) : null}
      {action ? <div className="fd-empty-state__action">{action}</div> : null}
    </div>
  );
}
